import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './visualizador.component.html'
})
export class VisualizadorComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/visualizador/visualizador.component.ts